import React from 'react';
import ReactDOM from 'react-dom';
import './fonts/ZillaSlab/ZillaSlab-SemiBold.ttf';
import './index.css';
import Router from './components/Router';

ReactDOM.render(
  <React.StrictMode>
    <Router />
  </React.StrictMode>,
  document.getElementById('root')
);
